import React, { useState } from 'react';
import { Phone, Volume2, ArrowUpRight, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { VoiceCallActions } from './VoiceCallActions';

const VoicePrimaryControls = ({ voice, copy, prefix }) => {
  const [consent, setConsent] = useState(false);
  if (voice.status === 'connected') return <VoiceCallActions voice={voice} copy={copy} prefix={prefix} />;
  if (voice.active) return <Button onClick={voice.end} className="voice-end-button w-full" data-testid={`${prefix}-cancel-button`}><Loader2 size={16} className="animate-spin" />{copy.cancel}</Button>;
  const disabled = !consent || voice.saveStatus === 'saving' || voice.saveStatus === 'error';
  return <>
    <label className="consent-line voice-consent"><input type="checkbox" checked={consent} onChange={event => setConsent(event.target.checked)} data-testid={`${prefix}-consent-checkbox`} /><span>{copy.consent}</span></label>
    <Button onClick={voice.start} disabled={disabled} className="gold-button w-full" data-testid={`${prefix}-start-button`}><Phone size={17} />{voice.messages.length ? copy.restart : copy.start}</Button>
  </>;
};

export const VoiceControls = ({ voice, copy, prefix, demo, onReview }) => {
  const canReview = !demo && !voice.active && voice.messages.some(message => message.role === 'user' && message.content);
  const review = async () => { if (await voice.save()) onReview(voice.sessionId); };
  return <div className="voice-controls">
    {voice.playbackBlocked && voice.active && <Button onClick={voice.play} className="voice-sound-button" data-testid={`${prefix}-enable-sound`}><Volume2 size={16} />{copy.playback}</Button>}
    <VoicePrimaryControls voice={voice} copy={copy} prefix={prefix} />
    {canReview && <button className="review-enquiry-link voice-review" onClick={review} disabled={voice.saveStatus === 'saving'} data-testid={`${prefix}-review-enquiry`}>{copy.review}<ArrowUpRight size={15} /></button>}
  </div>;
};